import { types } from './actions';

export default function roleReducer(state = { isRolePageLoading: true, roles: [] }, action) {
  switch (action.type) {
    case types.UPDATING_ROLE:
    case types.CREATING_ROLE: {
      return { ...state, isRoleFormLoading: true };
    }
    case types.UPDATE_ROLE_FAILED:
    case types.CREATE_ROLE_FAILED: {
      return { ...state, isRoleFormLoading: false };
    }
    case types.LOADING_ROLES: {
      return { ...state, isRolePageLoading: true, roles: [] };
    }
    case types.LOAD_ROLES_SUCCESSFULLY: {
      return { ...state, isRolePageLoading: false, roles: action.roles };
    }
    case types.DELETING_ROLE: {
      return { ...state, isRoleListPageLoading: true };
    }
    case types.DELETE_ROLE_SUCCESSFULLY: {
      return {
        ...state,
        isRoleListPageLoading: false,
        roles: state.roles.filter(({ id: roleId }) => roleId !== action.roleId),
      };
    }
    case types.DELETE_ROLE_FAILED: {
      return { ...state, isRoleListPageLoading: false };
    }
    case types.UPDATE_ROLE_SUCCESSFULLY:
    case types.CREATE_ROLE_SUCCESSFULLY: {
      const { role } = action;
      return {
        ...state,
        roles: [...state.roles.filter(({ id: roleId }) => roleId !== role.id), role],
        isRoleFormLoading: false,
      };
    }
    default:
      return state;
  }
}
